// extracted by mini-css-extract-plugin
export default {"carousel":"W7","ingredient":"X7","swiper-pagination-bullet":"Y7","swiper-pagination-bullet-active":"Z7","swiper_carousel":"a8","swiper_pagination":"b8","arrows":"c8","arrow_navigation":"e8"};
    if(module.hot) {
      // 1715091685836
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  